export default __webpack_public_path__ + "static/winter32-6c708709b0294bdcde29738985e44d7e.webp";